<!-- <nav style="right: 0;"
  class="rtl md:right-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden flex flex-wrap items-center justify-between relative lg:w-3/12 z-10 py-4 px-6"
>
<div
class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-t mt-32"
>
<div class="px-6">
  <div class="flex flex-wrap justify-center">
    <div class="w-full px-4 flex justify-center">
      <div class="relative">
        <img
          alt="..."
          src="assets/img/team-2-800x800.jpg"
          class="shadow-xl rounded-full h-auto align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px"
        />
      </div>
    </div>
    
  </div>
  <div class="text-center mt-24">
    <h3
      class="text-xl font-semibold leading-normal text-blueGray-700 mb-2"
    >
      Jenna Stones
    </h3>
    <div
      class="text-sm leading-normal mt-0 mb-2 text-blueGray-400 font-bold uppercase"
    >
      <i class="fas fa-map-marker-alt mr-2 text-lg text-blueGray-400"></i>
      Los Angeles, California
    </div>
  </div>
  <div class="mt-10 py-10 border-t border-blueGray-200">
    <div class="flex flex-wrap justify-center">
      <div class="w-full lg:w-9/12">
        <ul class="md:flex-col md:min-w-full flex flex-col list-none">
          <li class="items-center"><a [routerLink]="['/admin/account']"
            class="text-lg uppercase p-4 font-bold block rounded-lg"
            routerLinkActive
            #userAccount="routerLinkActive"
            [ngClass]="
              userAccount.isActive
                ? 'text-primary hover:text-primary bg-primary-light'
                : 'text-blueGray-700 hover:text-blueGray-500'
            ">
              <i class="fas fa-tv mr-2 text-sm opacity-75"></i>
              حساب کاربری </a></li>
          <li class="items-center"><a [routerLink]="['/admin/appointment']"
            class="text-lg uppercase p-4 font-bold block rounded-lg"
            routerLinkActive
            #userAppointment="routerLinkActive"
            [ngClass]="
              userAppointment.isActive
                ? 'text-primary hover:text-primary bg-primary-light'
                : 'text-blueGray-700 hover:text-blueGray-500'
            ">
              <i class="fas fa-tools mr-2 text-sm text-blueGray-300"></i>
              نوبت </a>
          </li>
          <li class="items-center"><a routerlinkactive=""
              class="text-lg uppercase p-4 font-bold block text-blueGray-700 hover:text-blueGray-500"
              href="#">
              <i class="fas fa-table mr-2 text-sm text-blueGray-300"></i>
              پیام </a></li>
          <li class="items-center"><a [routerLink]="['/admin/wallet']"
            class="text-lg uppercase p-4 font-bold block rounded-lg"
            routerLinkActive
            #userWallet="routerLinkActive"
            [ngClass]="
              userWallet.isActive
                ? 'text-primary hover:text-primary bg-primary-light'
                : 'text-blueGray-700 hover:text-blueGray-500'
            ">
              <i class="fas fa-map-marked mr-2 text-sm text-blueGray-300"></i>
              کیف پول </a></li>
          <li class="items-center"><a routerlinkactive=""
              class="text-lg uppercase p-4 font-bold block text-blueGray-700 hover:text-blueGray-500"
              href="#">
              <i class="fas fa-map-marked mr-2 text-sm text-blueGray-300"></i>
              خروج </a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
</div>

</nav> -->

<nav
  class="rtl md:right-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6"
>
  <div
    class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
  >
    <!-- Brand -->
    <a
      href="/"
      class="flex text-right md:pb-2 text-blueGray-600 mr-0 cursor-pointer text-2xl z-100 font-semibold p-4 px-0"
    >
      <img src="../../../assets/img/Ostadvisit-Logo-color.svg" class="w-10" alt="">
      <span class="block sm:hidden m-2"> استاد ویزیت </span>
      <span class="hidden sm:block m-2"> استاد ویزیت </span>
    </a>
    <!-- Toggler -->
    <button
      class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
      type="button"
      (click)="toggleCollapseShow('bg-white m-2 py-3 px-6')"
    >
      <i class="fas fa-bars"></i>
    </button>
    <!-- User -->
    <!-- <ul class="md:hidden items-center flex flex-wrap list-none">
      <li class="inline-block relative">
        <app-notification-dropdown class="block"></app-notification-dropdown>
      </li>
      <li class="inline-block relative">
        <app-user-dropdown class="block"></app-user-dropdown>
      </li>
    </ul> -->
    <!-- Collapse -->
    <div
      class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-2 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
      [ngClass]="collapseShow"
    >
      <!-- Collapse header -->
      <div
        class="md:min-w-full md:hidden block pb-4 mb-4 border-solid border-blueGray-200"
      >
        <div class="flex flex-wrap">
          <div class="w-6/12">
            <!-- <a
              href="/"
              class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
            >
              استاد ویزیت
            </a> -->
          </div>
          <div class="w-6/12 flex justify-end">
            <button
              type="button"
              class="cursor-pointer text-black opacity-50 md:hidden mt-5 px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
              (click)="toggleCollapseShow('hidden')"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        
      </div>

      <!-- Divider -->
      <hr class="my-4 md:min-w-full" />
      <!-- Navigation -->

      <ul class="md:flex-col md:min-w-full flex flex-col list-none">
        <li class="items-center"><a [routerLink]="['/user/account']"
          class="text-lg uppercase p-4 font-bold rounded-lg flex"
          routerLinkActive (click)="toggleCollapseShow('hidden')"
          #userAccount="routerLinkActive"
          [ngClass]="
            userAccount.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-gray-500 hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10" [src]="userAccount.isActive?'../../../assets/img/icon/User.svg':'../../../assets/img/icon/User_outline.svg'" alt="">
            حساب کاربری </a></li>
        <li class="items-center"><a [routerLink]="['/user/appointment']"
          class="text-lg uppercase p-4 font-bold flex rounded-lg"
          routerLinkActive (click)="toggleCollapseShow('hidden')"
          #userAppointment="routerLinkActive"
          [ngClass]="
            userAppointment.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-gray-500 hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10" [src]="userAppointment.isActive?'../../../assets/img/icon/Document.svg':'../../../assets/img/icon/Document_outline.svg'" alt="">
            نوبت </a>
        </li>
        <li class="items-center"><a [routerLink]="['/user/message']"
            class="text-lg uppercase p-4 font-bold text-gray-500 hover:text-blueGray-500 flex"
            routerLinkActive (click)="toggleCollapseShow('hidden')"
          #message="routerLinkActive"
          [ngClass]="
            message.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-gray-500 hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10" [src]="message.isActive?'../../../assets/img/icon/chat.svg':'../../../assets/img/icon/chat_outline.svg'" alt="">
            پیام </a></li>
        <li class="items-center"><a [routerLink]="['/user/wallet']"
          class="text-lg uppercase p-4 font-bold rounded-lg flex"
          routerLinkActive (click)="toggleCollapseShow('hidden')"
          #userWallet="routerLinkActive"
          [ngClass]="
            userWallet.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-gray-500 hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10" [src]="userWallet.isActive?'../../../assets/img/icon/Wallet.svg':'../../../assets/img/icon/Wallet_outline.svg'" alt="">
            امور مالی </a></li>
        <!-- <li class="items-center"><a [routerLink]="['/user/requests']"
          class="text-lg uppercase p-4 font-bold rounded-lg flex"
          routerLinkActive
          #requests="routerLinkActive"
          [ngClass]="
            requests.isActive
              ? 'text-primary hover:text-primary bg-primary-light'
              : 'text-gray-500 hover:text-blueGray-500'
          ">
            <img class="px-2 mx-1 w-10" [src]="requests.isActive?'../../../assets/img/icon/Wallet.svg':'../../../assets/img/icon/Wallet_outline.svg'" alt="">
            درخواست مالی </a></li>     -->
        <li class="items-center"><a routerlinkactive=""  (click)="modal.open();toggleCollapseShow('hidden')"
            class="text-lg uppercase p-4 cursor-pointer font-bold flex text-gray-500 hover:text-blueGray-500">
            <img class="px-2 mx-1 w-10" src="../../../assets/img/icon/Logout_outline.svg" alt="">
            خروج </a></li>
      </ul>


      



      <!-- <ul class="md:flex-col md:min-w-full flex flex-col list-none">
        <li class="items-center">
          <a
            [routerLink]="['/admin/dashboard']"
            class="text-xs uppercase py-3 font-bold block"
            routerLinkActive
            #adminDashboard="routerLinkActive"
            [ngClass]="
              adminDashboard.isActive
                ? 'text-red-600 hover:text-red-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
          >
            <i
              class="fas fa-tv mr-2 text-sm"
              [ngClass]="
                adminDashboard.isActive ? 'opacity-75' : 'text-blueGray-300'
              "
            ></i>
            Dashboard
          </a>
        </li>

        <li class="items-center">
          <a
            [routerLink]="['/admin/settings']"
            class="text-xs uppercase py-3 font-bold block"
            routerLinkActive
            #adminSettings="routerLinkActive"
            [ngClass]="
              adminSettings.isActive
                ? 'text-red-600 hover:text-red-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
          >
            <i
              class="fas fa-tools mr-2 text-sm"
              [ngClass]="
                adminSettings.isActive ? 'opacity-75' : 'text-blueGray-300'
              "
            ></i>
            Settings
          </a>
        </li>

        <li class="items-center">
          <a
            [routerLink]="['/admin/tables']"
            class="text-xs uppercase py-3 font-bold block"
            routerLinkActive
            #adminTables="routerLinkActive"
            [ngClass]="
              adminTables.isActive
                ? 'text-red-600 hover:text-red-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
          >
            <i
              class="fas fa-table mr-2 text-sm"
              [ngClass]="
                adminTables.isActive ? 'opacity-75' : 'text-blueGray-300'
              "
            ></i>
            Tables
          </a>
        </li>

        <li class="items-center">
          <a
            [routerLink]="['/admin/maps']"
            class="text-xs uppercase py-3 font-bold block"
            routerLinkActive
            #adminMaps="routerLinkActive"
            [ngClass]="
              adminMaps.isActive
                ? 'text-red-600 hover:text-red-700'
                : 'text-blueGray-700 hover:text-blueGray-500'
            "
          >
            <i
              class="fas fa-map-marked mr-2 text-sm"
              [ngClass]="
                adminMaps.isActive ? 'opacity-75' : 'text-blueGray-300'
              "
            ></i>
            Maps
          </a>
        </li>
      </ul> -->

    </div>


    <!-- <div>

      <ul class="hidden sm:block">
        <li class="items-center"><a href="/"
          class="text-lg uppercase p-4 font-bold flex text-gray-500 hover:text-blueGray-500">
          <img class="px-2 mx-1 w-10" src="../../../assets/img/icon/home.svg" alt="">
          صفحه اصلی </a></li>
    
      </ul>
    </div> -->

  </div>
</nav>



<app-modal #modal>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      خروج
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="modal.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative py-4 flex-auto md:me-32">
    <p class="mt-4 mb-12 text-blueGray-500 text-base text-start leading-relaxed">
      آیا قصد دارید از سایت خارج شوید؟
    </p>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between py-2 border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="modal.close()">
      انصراف
    </button>
    <button
      class="bg-red-500 text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow my-2 ease-linear transition-all duration-150"
      type="button" (click)="logout()">
      خروج
    </button>
  </div>
</app-modal>